import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "react-select";
import { fetchZones } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { fetchAllocateZoneById } from "services/allocateZone";

const ZoneDropDown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  required,
  allZone,
  allOption,
  selectedZone,
}) => {
  const ZoneName = getValues().zone_type;
  const selectedZoneName = watch("zone_id");
  const auth = useSelector((state) => state.jwtAuthreducer);
  const { employee_code_id } = auth?.user;

  const [allZoneIds, setAllZoneIds] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    data: allocatedZones,
    isLoading: isAllocatedLoading,
    isError: isAllocatedError,
    error: allocatedError,
  } = useQuery(
    ["fetch-allocated-zones", employee_code_id],
    () => fetchAllocateZoneById({ employee_code_id }),
    {
      staleTime: DROPDOWN_STALE_TIME,
      enabled: !!employee_code_id && !allZone,
    }
  );

  const {
    data: allZonesData,
    isLoading: isAllZonesLoading,
    isError: isAllZonesError,
    error: allZonesError,
  } = useQuery(["fetch-all-zones"], () => fetchZones(), {
    staleTime: DROPDOWN_STALE_TIME,
    enabled: allZone,
  });

  const zonesData = allZone
    ? allZonesData?.data?.zone_data
    : allocatedZones?.data;
  const isLoading = allZone ? isAllZonesLoading : isAllocatedLoading;
  const error = allZone ? allZonesError : allocatedError;

  const options = useMemo(() => {
    if (!zonesData) return [];

    const mappedZones = zonesData.map((zone) => {
      if (allZone) {
        return {
          value: zone.id || zone.zone_id,
          label: zone.zone_name || zone.name,
        };
      } else {
        return {
          value: zone?.zone_id,
          label: zone?.zone_obj?.zone_name,
        };
      }
    });

    if (allOption) {
      return [{ value: "All", label: "All" }, ...mappedZones];
    }

    return mappedZones;
  }, [zonesData, allZone, allOption]);

  useEffect(() => {
    if (options.length > 0) {
      const ids = options
        .filter((opt) => opt.value !== "All")
        .map((opt) => opt.value);
      setAllZoneIds(ids);
    }
  }, [options]);

  useEffect(() => {
    if (rowData && options.length > 0 && !isInitialized) {
      const selectedOption = options.find(
        (option) => option.value === (rowData?.zone_obj?.id || rowData?.zone_id)
      );
      if (selectedOption) {
        setValue("zone_id", selectedOption.value, { shouldValidate: false });
      }
      setIsInitialized(true);
    }
  }, [rowData, options, setValue, isInitialized]);

  useEffect(() => {
    if (!selectedZone) return;
    if (isInitialized) return;
    if (!options.length) return;

    const storedZone = localStorage.getItem("zone_id");
    console.log("storedZone", storedZone);

    if (storedZone) {
      const found = options.find((opt) => opt.value == storedZone);

      if (found) {
        setValue("zone_id", found.value, { shouldValidate: false });
        setIsInitialized(true);
        console.log("found", found);
      }
    }
  }, [options, setValue, selectedZone]);

  const selectedOption = useMemo(() => {
    return options.find(
      (option) => option.value === selectedZoneName || option.value === ZoneName
    );
  }, [options, selectedZoneName, ZoneName]);

  const handleChange = useCallback(
    (selectedOption) => {
      const value = selectedOption ? selectedOption.value : "";
      setValue("zone_id", value, { shouldValidate: true });

      if (value === "All" && allZoneIds.length > 0) {
        setValue("allZoneIds", allZoneIds, { shouldValidate: false });
      } else {
        setValue("allZoneIds", [], { shouldValidate: false });
      }
    },
    [setValue, allZoneIds]
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading zones</div>;

  return (
    <Controller
      name="zone_id"
      control={control}
      rules={{
        required: required ? "Zone is required" : false,
        validate: (value) => {
          if (required && !value) return "Zone is required";
          return true;
        },
      }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          placeholder="Select Zone"
          value={selectedOption || null}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              height: "42px",
            }),
            option: (base) => ({
              ...base,
            }),
          }}
          onChange={(selectedOption) => {
            field.onChange(selectedOption ? selectedOption.value : "");
            handleChange(selectedOption);
          }}
          className={`react-select-container ${
            errors.zone_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default ZoneDropDown;
